function customConditionMax(value) {
  const { input } = this.validator;
  return input.value_type === 'percent' || value <= 999999999999;
}

export default {
  message: 'Value cannot exceed 999,999,999,999',
  fn: customConditionMax
};
